// extracted by mini-css-extract-plugin
export const container = "layout-module--container--ZOr-X";